import axios from "@/axios.js";
const editProcess = async ({ commit }, body) => {
  const { id, ...obj } = body;
  let url = `api/userProcesses/${id}`;
  axios
    .put(url, obj)
    .then(() => {
      commit("SET_BLANK", "");
    })
    .catch((err) => {
      console.log(err);
    });
};
const fetchOneProcess = async ({ commit }, id) => {
  let url = `api/userProcesses/${id}`;

  try {
    const response = await axios.get(url);
    commit("SET_PROCESS", response.data);
  } catch (error) {
    console.log(error);
  }
};

const setProcessToNull = async ({ commit }) => {
  commit("SET_PROCESS", null);
};

const fetchProcesTypes = async ({ commit }) => {
  let url = `api/userProcesses/types`;
  axios
    .get(url)
    .then((response) => {
      commit("SET_TYPES", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};
const fetchProcesSettings = async ({ commit }) => {
  let url = `api/userProcesses/settings`;
  axios
    .get(url)
    .then((response) => {
      commit("SET_SETTINGS", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};
const setChosenSelectName = ({ commit }, name) => {
  commit("SET_CHOSEN_SELECT", name);
};

const fetchProcesses = async ({ commit }, filterData) => {
  const {
    status,
    type,
    filterBy,
    filterWith,
    filterBySecond,
    filterWithSecond,
    search,
  } = filterData;
  let url = `api/userProcesses?type=${type}`;
  if (status !== "") url += `&status=${status}`;

  if (filterBy !== "" && filterWith !== "" && status === "WAITING_FOR_CONTACT")
    url += `&${filterBy}=${filterWith}`;
  if (
    filterBySecond !== "" &&
    filterWithSecond !== "" &&
    status === "PENDING_ACTION"
  )
    url += `&${filterBySecond}=${filterWithSecond}`;

  if (search && search !== "") url += `&search=${search}`;

  try {
    const response = await axios.get(url);
    if (status === "WAITING_FOR_CONTACT") commit("SET_TODO", response.data);
    if (status === "PENDING_ACTION") commit("SET_DONE", response.data);
    if (status === "SUCCESS") commit("SET_SUCCESS", response.data);
    if (status === "LOST") commit("SET_LOST", response.data);
  } catch (error) {
    console.log(error);
  }
};

export default {
  fetchProcesses,
  fetchProcesTypes,
  fetchProcesSettings,
  fetchOneProcess,
  editProcess,
  setChosenSelectName,
  setProcessToNull,
};
